var _ = require('underscore/underscore.js');
var Base = require('front/components/Base/Base');

var template = require('./IndexPerspective.jinja');
require('./IndexPerspective.less');

module.exports = Base.extend({

    template: template,

    events: {
        'mouseenter .IndexPerspective-articlesItem': 'onMouseEnter',
        'click .IndexPerspective-articlesItem': 'onItemClick'
    },


    initialize: function (options) {
        this.options = options || {};

        Base.prototype.initialize.call(this, options);
    },


    onMouseEnter: function (e) {
        if (!app.settings.isDesktop) return;

        this.$('.IndexPerspective-articlesItem').removeClass('hovered');
        $(e.currentTarget).addClass('hovered');
    },


    onItemClick: function (e) {
        if (!app.settings.isTablet) return;

        if (!$(e.currentTarget).hasClass('hovered')) {
            e.stopPropagation(); //prevent link triger
            e.preventDefault();
        }

        this.$('.IndexPerspective-articlesItem').removeClass('hovered');
        $(e.currentTarget).addClass('hovered');
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/IndexPerspective/IndexPerspective.js
// module id = 178
// module chunks = 0